import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { appIcons } from "../../assets";
import { CURRENCY } from "../../lib/variables";
import { t } from "i18next";

const SubscriptionCard = ({ data, currentLanguage }) => {
  const theme = useTheme();
  const isPremium =
    data?.name?.en === "premium" || data?.name?.ro === "premium";

  return (
    <Box
      px={3.5}
      pt={2}
      // bgcolor={isPremium ? "white" : "text.darkBlue"}
      height={"100%"}
      position={"relative"}
      overflow={"hidden"}
      boxShadow={isPremium ? "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" : "none"}
      sx={{
        background: theme.palette.text.darkBlue,
        "&:hover": {
          borderRadius: 3,
          background: "white",
          height: "115%",
        },
        "&:hover > div > p": {
          color: "black",
          fontWeight: "600",
        },
        "&:hover > .bestPlan > p": {
          color: "white",
          fontWeight: "400",
        },
        "&:hover > div > hr": {
          borderColor: "black",
        },
        "&:hover > div > div > div > p": {
          color: "black",
        },
        "&:hover > div > div > div > h4": {
          color: "black",
        },
        "&:hover > div > ul li > .MuiListItemText-root > span": {
          color: "black",
        },
      }}
    >
      {isPremium && (
        <Box
          className="bestPlan"
          bgcolor={"text.orangeRed"}
          position={"absolute"}
          px={3}
          py={0.5}
          top={0}
          right={0}
          textTransform={"capitalize"}
          sx={{
            borderBottomLeftRadius: "12px",
          }}
        >
          <Typography variant="body2" color={"text.white"}>
            {t("bestPlan")}
          </Typography>
        </Box>
      )}

      <Box>
        <Typography
          variant="body1"
          // color={isPremium ? "text.black" : "text.white"} // Text color changes to black if Premium
          color={"text.white"}
          textTransform={"capitalize"}
        >
          {data.name[currentLanguage]}
        </Typography>
        <Stack
          // direction={"row"}
          // alignItems={"flex-end"}
          // justifyContent={"space-between"}
          mt={1.5}
          spacing={1}
        >
          <Stack direction={"row"} alignItems={"flex-end"} spacing={1}>
            <Typography
              variant="h4"
              fontWeight={600}
              color={"text.white"}
              fontSize={26}
            >
              <span style={{ fontSize: "inherit", marginRight: 5 }}>
                {CURRENCY}
              </span>
              {data.price}
            </Typography>
            <Typography variant="body1" color={"text.white"} fontSize={13}>
              /{t("monthly")}
            </Typography>
          </Stack>
          <Stack direction={"row"} alignItems={"flex-end"} spacing={1}>
            <Typography
              variant="h4"
              fontWeight={600}
              color={"text.white"}
              fontSize={26}
            >
              <span style={{ fontSize: "inherit", marginRight: 5 }}>
                {CURRENCY}
              </span>
              {data.yearlyPrice}
            </Typography>
            <Typography variant="body1" color={"text.white"} fontSize={13}>
              /{t("yearly")}
            </Typography>
          </Stack>
        </Stack>
        {/* <Divider
          sx={{
            borderColor: isPremium ? "text.black" : "text.white", // Divider color changes if Premium
            my: 3,
          }}
        />
        <Typography
          variant="body2"
          color={isPremium ? "text.black" : "text.white"} // Text color changes if Premium
        >
          monthly new bookings
        </Typography>
        <Typography
          variant="body2"
          color={isPremium ? "text.black" : "text.white"} // Text color changes if Premium
        >
          Plus{" "}
          <Typography
            component={"span"}
            color={isPremium ? "text.orangeRed" : "text.orangeRed"}
          >
            {data.invite} free
          </Typography>{" "}
          reminders Invites
        </Typography> */}
      </Box>

      <Box mt={2.5}>
        {/* <GlobalButton
          btnText={"Create a free account"}
          styleProps={{
            my: 4,
            height: 45,
            backgroundColor: "text.orangeRed", // Button background changes if Premium
          }}
        /> */}
        <Typography
          variant="body1"
          color={"text.white"} // Text color changes if Premium
          textTransform={"capitalize"}
        >
          {t("features")}
        </Typography>
        <Divider
          sx={{
            borderColor: "text.white", // Divider color changes if Premium
            mt: 1.5,
          }}
        />
        <List>
          {data.features.map((val, ind) => {
            return (
              <ListItem disablePadding key={ind}>
                <ListItemIcon
                  sx={{
                    minWidth: 32,
                  }}
                >
                  <img src={appIcons.checkOrangeRedIcon} width={20} />
                </ListItemIcon>
                <ListItemText
                  primary={val.title[currentLanguage]}
                  sx={{
                    "& .MuiListItemText-primary": {
                      color: "text.white", // Text color changes if Premium
                      fontSize: "0.75rem",
                    },
                  }}
                />
              </ListItem>
            );
          })}
        </List>
      </Box>
    </Box>
  );
};

export default SubscriptionCard;
